import { IsEmail } from 'class-validator';

import { ERROR_MESSAGE, HAS_KOR } from './constants';
import { NotMatches } from './decorator';

class EmailValidator {
  @IsEmail({}, { message: ERROR_MESSAGE.INVALID_EMAIL })
  @NotMatches(RegExp(HAS_KOR), {
    message: ERROR_MESSAGE.INVALID_EMAIL,
  })
  email: string;
}

export default EmailValidator;
